import React from 'react';
import { Pillar } from '../types';

interface PillarSidePanelProps {
  isOpen: boolean;
  pillar: Pillar;
  onClose: () => void;
  onUpdate: (pillar: Pillar) => void;
}

const PillarSidePanel: React.FC<PillarSidePanelProps> = ({
  isOpen,
  pillar,
  onClose,
  onUpdate
}) => {
  if (!isOpen) return null;

  return (
    <div className="side-panel-overlay">
      <div className="side-panel">
        <div className="side-panel-header">
          <h3>Edit {pillar.name}</h3>
          <button className="side-panel-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="side-panel-content">
          <p>Pillar side panel functionality coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default PillarSidePanel; 